import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function PharmDetail(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [addedby, setaddedby] = useState({ username: '' });
  const [rows, setRows] = useState([]);
  const [mode, setMode] = useState({ mode: '' });
  const [userData, setUserData] = useState([]);
  const [combinedData, setcombinedData] = useState([]);
  const [returnData, setreturnData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};
 const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};
  const handleUser = (event) => {
      setaddedby({
        ...addedby,
        username: event.target.value
      });
    };
    const handleMode = (event) => {
      setMode({
        ...mode,
        mode: event.target.value
      });
    };
  useEffect(() => {
    try {
        axios.get(`${baseUrl}user-search/`)
        .then(function (response) {
            setUserData(response.data);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
      fetchData();
  }, [startDate, endDate, addedby, mode]);
  useEffect(() => {
      if (combinedData.length > 0) {
        setRows(combinedData);
      }
  }, [combinedData]);

  function fetchData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  const url = `${baseUrl}all-pharm-sale/?start_date=${startDateString}&end_date=${endDateString}&addedby=${addedby.username}&mode=${mode.mode}&status=1`;
  axios.get(url)
    .then(response => {
      setcombinedData(response.data);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
  }

const columnsInvoiced = [
    { field: "add_date_date", headerName: "Date", width: 110 },
    { field: "pat__pat_id", headerName: "Patient ID", width: 100 },
    { field: "patient", headerName: "Patient Name", width: 130 },
    { field: "sale_type", headerName: "Sale Type", width: 120 },
    {
      field: "invoice",
      headerName: "Invoice/Receipt No",
      renderCell: (params) => (
        <Link
          to={
            params.row.sale_type === 'IndentBill'
              ? `/pharm-invoice-indent/${params.row.sale_id}`
              : `/pharm-invoice-other/${params.row.sale_id}`
          }
          target="_blank"
        >
          {params.row.sale_id}
        </Link>
      ),
      width: 160,
    },
    {
      field: 'fee',
      headerName: 'Total Amount',
      width: 130,
      renderCell: (params) => params.row.total,
    },
    {
      field: 'paid',
      headerName: 'Paid Amount',
      width: 130,
      renderCell: (params) => params.row.paid,
    },
    {
      field: 'balance',
      headerName: 'Balance Amount',
      width: 150,
      renderCell: (params) => params.row.balance,
    },
    {
      field: 'disc',
      headerName: 'Disc Amount',
      width: 130,
      renderCell: (params) => params.row.disc,
    },
    {
      field: 'mode',
      headerName: 'Payment Mode',
      width: 150,
      renderCell: (params) => params.row.mode,
    },

  { field: 'addedby', headerName: "Cashier", width: 120 },
  ];

const FooterInvoiced = ({ rows }) => {
  let totalAmountTotal = 0;
  let TotalPaid = 0;
  let balanceTotal = 0;
  let discTotal = 0;

  rows.forEach((payment) => {
      totalAmountTotal += Number(payment.total);
      TotalPaid += Number(payment.paid);
      balanceTotal += Number(payment.balance);
      discTotal += isNaN(payment.disc) ? 0 : Number(payment.disc);
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '2px' }}>
      <div>Total</div>
      <div>{totalAmountTotal}</div>
      <div>{TotalPaid}</div>
      <div>{balanceTotal}</div>
      <div>{discTotal}</div>
      <div colSpan="2"></div>
    </div>
  );
};


  useEffect(() => {
      fetchrefData();
  }, [startDate, endDate]);

  function fetchrefData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  const url = `${baseUrl}sale-return-report/?start_date=${startDateString}&end_date=${endDateString}&addedby=${addedby.username}&mode=${mode.mode}&status=1`;
  axios.get(url)
    .then(response => {
      setreturnData(response.data);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
  }

    let TotalPaid = 0;
    let balanceTotal = 0;
    let discTotal = 0;
    let totalAmountTotal = 0;
    for (const payment of combinedData) {
       if (!isNaN(payment.paid)) {
        TotalPaid += Number(payment.paid);
      }
      if (!isNaN(payment.balance)) {
        balanceTotal += Number(payment.balance);
      }
      if (!isNaN(payment.disc)) {
        discTotal += Number(payment.disc);
      }

      totalAmountTotal += Number(payment.total);
    }
    const totalRow = (
      <tr>
        <td colSpan="5">Total</td>
        <td>{totalAmountTotal.toFixed(2)}</td>
        <td>{TotalPaid.toFixed(2)}</td>
        <td>{balanceTotal.toFixed(2)}</td>
        <td>{discTotal.toFixed(2)}</td>
        <td colSpan="2"></td>
      </tr>
    );
  const today = new Date();

  const columns1 = [
    { field: 'add_date_date', headerName: 'Date', width: 120 },
    { field: 'pat__pat_id', headerName: 'Patient ID', width: 100},
    { field: 'pat__patient', headerName: 'Patient', width: 200 },
    { field: 'return_type', headerName: 'Return Type', width: 110 },
    { field: 'return_no', headerName: 'Return Receipt',
        renderCell: (params) => (
          <Link to={`/pharm-invoice-return/${params.row.return_no}`} target="_blank">
            {params.row.return_no}
          </Link>
      ),
      width: 120 },
    { field: 'total', headerName: 'Return Amount', width: 150 },
    { field: 'addedby', headerName: 'addedby', width: 100 },
  ];

  const getTotal1 = (rows1, field) => {
    return rows1.reduce((total1, row1) => total1 + parseFloat(row1[field]), 0);
  };

   const Footer1 = ({ rows1 }) => {
      const totalreturnAmount1 = getTotal1(rows1, 'return_amount');
      return (
        <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '2px' }}>
          <div>Total</div>
          <div>{totalreturnAmount1}</div>
        </div>
      );
    };

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> Payment Detail Report</h3>
      <div className="row">
        <div className="col-md-4">
            <label className="control-label">Select Date</label>
            <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText={'Please select From date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                maxDate={today}
                placeholderText={'Please select To date'}
                dateFormat="dd/MM/yyyy"
                showMonthDropdown
                showYearDropdown
            />
            </div>

            <div className="col-md-4">
            <div className="mb-4 mt-4 form-control">
              <label htmlFor="user" className="form-label">Search by Cashier</label>
              <select name="user" id="username" value={addedby.user} className="form-control"
                            onChange={(event) => handleUser(event)}>
                            <option value="">Select Cashier</option>
              {userData.map((User,index) => (
                <option key={index} value={User.username}>{User.username}</option>
              ))}
            </select>
            </div>
            </div>
            <div className="col-md-4">
            <div className="mb-4 mt-4 form-control">
              <label htmlFor="mode" className="form-label">Search by Sales Mode</label>
              <select name="mode" id="mode" value={mode.mode} className="form-control"
                onChange={(event) => handleMode(event)}>
                <option value="">Select Sales Mode</option>
                <option value="cash">Cash</option>
                <option value="card">Card</option>
                <option value="creditpay">Credit Payment</option>
                <option value="advance">Advance</option>
                <option value="UPI">UPI</option>
                <option value="indent">Indent</option>
              </select>
            </div>
            </div>
      </div>

    {!isLoading && combinedData.length > 0 ? (
    <div>
     <nav>
      <div className="nav nav-tabs" id="nav-tab" role="tablist">
      <button className="nav-link active border-success" id="nav-invoiced-tab" data-bs-toggle="tab"
            data-bs-target="#nav-invoiced" type="button" role="tab" aria-controls="nav-invoiced"
            aria-selected="true">Sales</button>
     <button className="nav-link  border-primary " id="nav-collected-tab" data-bs-toggle="tab"
        data-bs-target="#nav-collected" type="button" role="tab" aria-controls="nav-collected"
        aria-selected="false">Discount</button>
        <button className="nav-link  border-primary " id="nav-return-tab" data-bs-toggle="tab"
            data-bs-target="#nav-return" type="button" role="tab" aria-controls="nav-return"
            aria-selected="false">Sales Return</button>
      </div>
    </nav>
  <div className="tab-content" id="nav-tabContent">
     <div className="tab-pane fade show active" id="nav-invoiced" role="tabpanel" aria-labelledby="nav-invoiced-tab">
     <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
        Sales Report
       </h3>
           <div style={{ height: "100%", width: '100%' }}>
              <DataGrid
                sx={{
                  boxShadow: 4,
                  border: 4,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                rows={combinedData}
                columns={columnsInvoiced}
                pageSize={10}
                slots={{
                  toolbar: GridToolbar,
                  footer: () => <FooterInvoiced rows={combinedData} />,
                }}
                autoHeight
              />
            </div>
          </div>
      <div className="tab-pane" id="nav-collected" role="tabpanel" aria-labelledby="nav-collected-tab">
      <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
        Discount Report
       </h3>
      <div style={{ height: "100%", width: '100%' }}>
              <DataGrid
                sx={{
                  boxShadow: 4,
                  border: 4,
                  borderColor: 'primary.light',
                  '& .MuiDataGrid-cell:hover': {
                    color: 'primary.main',
                  },
                }}
                rows={combinedData.filter(payment => (payment.disc > 0 ))}
                columns={columnsInvoiced}
                pageSize={10}
                slots={{
                  toolbar: GridToolbar,
                  footer: () => <FooterInvoiced rows={combinedData.filter(payment => (payment.disc > 0 ))} />,
                }}
                autoHeight
              />
            </div>
          </div>
          <div className="tab-pane" id="nav-return" role="tabpanel" aria-labelledby="nav-return-tab">
              <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                Sales Return Report
               </h3>
               {!isLoading && returnData.length > 0 ? (
                  <div style={{ height: "100%", width: "100%" }}>
                    <DataGrid
                      className="mt-4"
                      sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                          color: 'primary.main',
                        },
                      }}
                      rows={returnData.map((row, index) => ({
                        ...row,
                        id: index + 1, // Add a unique id property to each row
                      }))}
                      columns={columns1}
                      pageSize={10}
                      slots={{
                        toolbar: GridToolbar,
                        footer1: () => <Footer1 rows={returnData} />,
                      }}
                      autoHeight
                    />
                  </div>
              ) : (
                <></>
              )}
          </div>


        </div>
        </div>
        ) : (
        <></>
      )}
    </section>
  );
}

export default PharmDetail;
